<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Home</v-toolbar-title>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="3" v-for="(summary, i) in summaries" :key="i" class="d-flex flex-column">
        <card-widget
          icon="mdi-counter"
          :label="summary.status"
          :value="summary.total"
        ></card-widget>
      </v-col>
       <v-col cols="12" lg="3" class="d-flex flex-column">
        <card-widget
          icon="mdi-calendar-today-outline"
          label="Today's Pending"
          :value="todaysPending"
        ></card-widget>
      </v-col>
      <!-- <v-col cols="3" lg="3">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="page-title">
              Summary
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Status
                    </th>
                    <th class="text-center">
                      Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(summary, i) in summaries" :key="i">
                    <td>{{ summary.status }}</td>
                    <td class="text-center">{{ summary.total }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col> -->

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="page-title">
              Next 7 Days
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(sched, i) in schedules" :key="i">
                    <th>{{ sched.assignedTo }}</th>
                    <td
                      v-for="(val, j) in sched.values"
                      :key="j"
                      class="text-center"
                    >
                      <span v-if="i != 0">{{ val }}</span>
                      <span v-else>{{ formatDate(val) }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols="3" lg="3">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="page-title">
              Today's Pending
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ todaysPending }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <!-- <SummaryReport></SummaryReport>
    <DailyRevenue></DailyRevenue>
    <DailyActivation></DailyActivation> -->
    <!-- <DailySignUp></DailySignUp> -->
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import CardWidget from "../../components/CardWidget.vue";
export default {
  name: "IbasDispatchDashboard",
  mixins: [ShareableMethods],
  components: {
    CardWidget,
  },

  data() {
    return {
      summaries: [],
      schedules: [],
      todaysPending: 0,
    };
  },

  methods: {
    async getDispatchSummary() {
      await this.$api
        .get("/dispatch/summary")
        .then((response) => {
          const res = response.data.data;
          console.log(res);
          this.summaries = res.countSummary;
          this.todaysPending = res.totalPending;
          this.schedules = res.sched;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },

  created() {
    this.getDispatchSummary();
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
